// Used when Best Offer is enabled but neither an explicit price nor a category
// AutoAcceptThreshold is available. Keep in lockstep with the backend constant
// BestOfferPricing.DefaultAutoAcceptThresholdPercent (GPMetals.Core/Services/BestOfferPricing.cs).
export const DEFAULT_AUTO_ACCEPT_THRESHOLD_PERCENT = 10;

/**
 * Mirrors backend BestOfferPricing.ResolveAutoAcceptPrice.
 * Precedence: explicit price > category threshold % off BIN > global default % off BIN.
 * Returns null when it cannot be computed (no valid Buy It Now price).
 */
export function resolveEffectiveAutoAcceptPrice(
  buyItNowPrice: number | null | undefined,
  explicitPrice: number | null | undefined,
  categoryThreshold: number | null | undefined,
): number | null {
  if (explicitPrice && explicitPrice > 0) return explicitPrice;
  if (!buyItNowPrice || buyItNowPrice <= 0) return null;

  const threshold =
    categoryThreshold && categoryThreshold > 0
      ? categoryThreshold
      : DEFAULT_AUTO_ACCEPT_THRESHOLD_PERCENT;

  return Math.round(buyItNowPrice * (1 - threshold / 100) * 100) / 100;
}
